import React from 'react';

import {
    Flex,
    Image,
    Spacer,
    Text,
} from '@zillow/constellation';

import Email from 'app/shared/images/email.svg';

import { StyledDialogBodyContainer } from 'app/shared/containers/ModalContainer/StyledComponents';

const propTypes = {};

const defaultProps = {};

const FeedListingDeactivateConfirmationHasErrorModal = () => (
    <StyledDialogBodyContainer className="FeedListingDeactivateConfirmationHasErrorModal">
        <Flex
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
        >
            <Spacer marginY="xs">
                <Image src={Email} alt="" />
            </Spacer>

            <Text as="div" fontType="bodyHeading">
                Contact a Zillow representative
            </Text>

            <Spacer paddingBottom="xs" />

            <Text as="div" fontType="body">
                Please email us for help with questions about your listing.
            </Text>
        </Flex>

        <Spacer paddingBottom="sm" />
    </StyledDialogBodyContainer>
);

FeedListingDeactivateConfirmationHasErrorModal.propTypes = propTypes;
FeedListingDeactivateConfirmationHasErrorModal.defaultProps = defaultProps;

export default FeedListingDeactivateConfirmationHasErrorModal;
